import { apiCall } from "./common/base.service"
import config from "../config/application"
import permission from "./permissions.service"
import dictionary from "../config/dictionary"
//url
const findData = "/find"
const save_file = "/register"
const delete_file = "/delete"
const edit_file = "/update"

class FileRequirementService {
  async getFilesRequirement(data) {
    const url = `${config.data.providers.fileRequirement.url}${findData}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await fileRequirementService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, data)
  }

  async getTypeList(concept) {
    const url = `${config.data.providers.fileRequirement.url}/find_type/${concept}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await fileRequirementService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("get", url)
  }

  async saveFile(json) {
    const url = `${config.data.providers.fileRequirement.url}${save_file}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await fileRequirementService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.add
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, json)
  }
  async deleteFile(files) {
    const url = `${config.data.providers.fileRequirement.url}${delete_file}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await fileRequirementService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.delete
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("delete", url, files)
  }

  async updateFile(file) {
    const url = `${config.data.providers.fileRequirement.url}${edit_file}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await fileRequirementService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.edit
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("put", url, file)
  }
  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_REQUEST,
      username,
      process.env.REACT_APP_SYSTEM_CODE,
      action
    )
  }
}

const fileRequirementService = new FileRequirementService()
export default fileRequirementService
